import { defineStore } from 'pinia';
import { reactive, toRefs } from 'vue';
import { api } from '@/server';
export const useDictionaryStore = defineStore('dictionaryStore', () => {
  const state = reactive({
    categories: {},
    expires: {}
  });
  const getDictionaryListApi = getAPI(api.dictionary.getList, {
    showError: false
  });
  const getDictionaryList = async cate => {
    const lastTime = state.expires[cate] || 0;
    const nowTime = new Date().getTime();
    const oldRows = state.categories[cate] || null;
    if (!oldRows || nowTime - lastTime > 1000 * 60 * 5) {
      const {
        error,
        rows = []
      } = await getDictionaryListApi({
        cate
      });
      if (error) return {
        rows: oldRows,
        error
      };
      if (oldRows && oldRows.length > 0) {
        state.expires[cate] = nowTime;
      } else {
        delete state.expires[cate];
      }
      state.categories[cate] = rows;
      return {
        rows
      };
    }
    return {
      rows: oldRows
    };
  };
  const clear = (cate = '') => {
    if (cate) {
      delete state.expires[cate];
      delete state.categories[cate];
    } else {
      state.expires = {};
      state.categories = {};
    }
  };
  return {
    ...toRefs(state),
    getDictionaryList,
    clear
  };
}, {
  persist: {
    enabled: true,
    key: 'useDictionaryStore',
    paths: ['categories', 'expires'],
    storage: localStorage
  }
});